import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CentralPortalServidor } from '../../../folha-pagamento/src/central-portal-servidor/central-portal-servidor.service';


@Injectable()
export class GruposPermitidosService {

  gruposPermitidos$: Observable<CentralPortalServidor[]>;

  temPermissao(grupoPortal: string): Observable<boolean> {
    return this.gruposPermitidos$.pipe(map(grupos => grupos.some(grupo => grupo.grupoPortalServidor.value === grupoPortal)));
  }
}


